"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var SelectButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/SelectButton"));
var SelectButtonGrid = function (_a) {
    var selectedValue = _a.selectedValue, options = _a.options, handleClick = _a.handleClick, props = __rest(_a, ["selectedValue", "options", "handleClick"]);
    return ((0, jsx_runtime_1.jsx)(Grid_1.default, __assign({ container: true, wrap: "wrap", spacing: props.size === 'large' ? 4 : 2 }, { children: options.map(function (option) { return ((0, jsx_runtime_1.jsx)(Grid_1.default, __assign({ md: 6, item: true }, { children: (0, jsx_runtime_1.jsx)(SelectButton_1.default, __assign({ color: "neutral", onClick: function () { return handleClick(option.value); }, logoUrl: option.logo, label: option.label, icon: option === null || option === void 0 ? void 0 : option.icon, description: option === null || option === void 0 ? void 0 : option.description }, props)) }), option.value)); }) })));
};
exports.default = SelectButtonGrid;
